/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import {WealthyEnv} from "helpers";

const propTypes = {
  closePopUp: PropTypes.func.isRequired
};

const AppDownloadPopUp = ({closePopUp}) => {
  const onClickHandler = () => {
    window.open(`${WealthyEnv.APP_DOWNLOAD_ONE_LINK}`);
  };

  const appDownloadIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/app-download-icon.png`;
  const appIllustration = `${WealthyEnv.HOMEPAGE_CDN_URL}/app-download-popup-illustration.png`;

  return (
    <Overlay>
      <PopUpContainer id="app-download-popup">
        <PopUp>
          <CoverImage src={appIllustration} />
          <Heading>
            Download Mobile App
          </Heading>
          <Text>
            Access tools to track and mange your family&apos;s investment portfolio for free
          </Text>
          <InputContainer>
            <SubmitButton
              id="app-download-popup--button"
              onClick={onClickHandler}
            >
              <img src={appDownloadIcon} alt="App download" />
              Install App
            </SubmitButton>
          </InputContainer>
          <CloseButton onClick={closePopUp} />
        </PopUp>
      </PopUpContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 999;
  display: none;

  @media (max-width: 48em) {
    display: flex;
  }
`;

const PopUpContainer = styled.section`
  width: 90%;
  height: auto;
  text-align: center;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: absolute;
  border-radius: 5px;
`;

const PopUp = styled.div`
  position: relative;
  background: white;
  color: #464646;
  border-radius: 10px;
  width: 100%;
  padding: 5rem 3rem;
  max-width: 400px;
`;

const InputContainer = styled.div`
  justify-self: center;
  align-self: center;
  display: inline-flex;
  align-items: center;
  margin-top: 3rem;
  margin: 3rem auto 0;
  width: 100%;
`;

const SubmitButton = styled.button`
  display: inline-block;
  border-radius: 5px;
  border: none;
  background: linear-gradient(45deg, #fe3464, #ea2062);
  box-shadow: 0 8px 35px rgba(254,52,100,0.4);
  color: #ffffff;
  width: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  font-size: 1.8rem;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
  font-family: Avenir-Medium;

  img {
    margin-right: 1rem;
    width: 15px;
  }
`;

const CoverImage = styled.img`
  width: 100%;
  max-width: 20rem;
  margin-bottom: 2rem;
  max-height: 100%;
`;

const Heading = styled.h2`
  font-family: Avenir-Heavy;
  font-size: 2.4rem;
  line-height: 1.4;
  color: #333;
`;

const CloseButton = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  margin: 0.5rem;
  cursor: pointer;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    margin-left: -12px;
    margin-top: -2px;
    left: 50%;
    top: 50%;
    width: 18px;
    height: 3px;
    background-color: #c3c9ec;
    position: absolute;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const Text = styled.p`
  font-family: Avenir-Light;
  font-size: 1.8rem;  
  margin: 0 auto 0;
  line-height: 1.5;
`;

AppDownloadPopUp.propTypes = propTypes;

export default AppDownloadPopUp;
